(function () {
  'use strict';
  var input = document.querySelector('[data-search-input]');
  var results = document.querySelector('[data-search-results]');
  if (!input || !results) return;
  var idle = results.innerHTML;
  var timer;
  var controller = null;
  var token = 0;
  function search(query, requestId) {
    if (requestId !== token) return;
    if (controller && controller.abort) controller.abort();
    controller = 'AbortController' in window ? new AbortController() : null;
    var url = (window.SSC.routes.search || '/search') + '/suggest.json?q=' + encodeURIComponent(query) + '&section_id=predictive-search&resources[type]=product,collection,page&resources[limit]=8';
    var options = controller ? { signal: controller.signal } : {};
    results.setAttribute('aria-busy', 'true');
    fetch(url, options)
      .then(function (response) { if (!response.ok) throw new Error('Search unavailable'); return response.json(); })
      .then(function (data) {
        if (requestId !== token) return;
        var html = data && data.sections && data.sections['predictive-search'];
        results.innerHTML = html || '<p class="muted">Nenhum resultado. Tente outra busca ou explore os drops.</p>';
        results.setAttribute('aria-busy', 'false');
      })
      .catch(function (error) {
        if (requestId !== token || error.name === 'AbortError') return;
        results.setAttribute('aria-busy', 'false');
        results.textContent = 'A busca está indisponível agora.';
      });
  }
  input.addEventListener('input', function () {
    clearTimeout(timer); token += 1; var id = token; var query = input.value.trim();
    if (query.length < 2) { if (controller && controller.abort) controller.abort(); results.innerHTML = idle; results.setAttribute('aria-busy', 'false'); return; }
    timer = setTimeout(function () { search(query, id); }, 220);
  });
})();
